import TimeReminder from "./TimeReminder";
import { QuizStats } from "../../../../context/QuizContext";

function TimeRemaining() {
    const { endTime } = QuizStats();

    return (
        <div className="flex flex-col items-center justify-center gap-4 py-5 bg-white shadow-lg rounded-xl">
            <p className="px-4 py-3 font-bold rounded-full md:text-xl text-md bg-gray-color-lighter w-fit text-blue-color-primary">
                الوقت المتبقي
            </p>
            <span dir="ltr" className="font-bold text-secondary-color">
                <TimeReminder endTime={endTime} />
            </span>
        </div>
    );
}

export default TimeRemaining;
